<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="toc">
<h1 class="ctfm"><a class="page" id="pvi"></a><a class="page" id="pvii"></a>Contents</h1>
<p class="tocfm"><a class="xref" href="#/chikramer0007#acknow">Acknowledgments</a></p>
<p class="tocfm"><a class="xref" href="#/chikramer0008#pref">Preface</a></p>
<p class="tocpt"><a class="xref" href="#/chikramer0009#pt01">Preliminaries</a></p>
<p class="toc"><a class="xref" href="#/chikramer0010#ch01">1. The Chromatic Moment in Enlightenment Thought</a></p>
<p class="toc1"><a class="xref" href="#/chikramer0010#ahaft0101"><i>A Preamble on Portraiture and Language</i></a></p>
<p class="toc1"><a class="xref" href="#/chikramer0010#ah0101"><i>The Chromatic Moment</i></a></p>
<p class="tocpt"><a class="xref" href="#/chikramer0011#pt02">Moments Musicaux</a></p>
<p class="toc"><a class="xref" href="#/chikramer0012#ch02">2. The Fugal Moment: On a Few Bars in Mozart’s Quintet in C Major, K. 515</a></p>
<p class="toc"><a class="xref" href="#/chikramer0013#ch03">3. Hearing the Silence: On a Much-Theorized Moment in a Sonata by Emanuel Bach</a></p>
<p class="tocpt"><a class="xref" href="#/chikramer0014#pt03">The Klopstock Moment</a></p>
<p class="toc"><a class="xref" href="#/chikramer0015#ch04">4. Oden von Klopstock in Musik gesetzt . . .</a></p>
<p class="toc"><a class="xref" href="#/chikramer0016#ch05">5. Composing Klopstock: Gluck contra Bach</a></p>
<p class="toc1"><a class="xref" href="#/chikramer0016#ah0501"><i>“A Poet among Composers”</i></a></p>
<p class="toc1"><a class="xref" href="#/chikramer0016#ah0502"><i>“A Klopstock Who Worked in Tones”</i></a></p>
<p class="toc"><a class="xref" href="#/chikramer0017#ch06">6. Beethoven: In Search of Klopstock</a></p>
<p class="tocpt"><a class="xref" href="#/chikramer0018#pt04">Dramma per Musica</a></p>
<p class="toc"><a class="xref" href="#/chikramer0019#ch07">7. <i>Anagnorisis</i>: Gluck and the Theater of Recognition</a></p>
<p class="toc"><a class="xref" href="#/chikramer0020#ch08">8. Cherubino’s Leap</a></p>
<p class="toc"><a class="xref" href="#/chikramer0021#ch09">9. Konstanze’s Tears</a></p>
<p class="tocbm"><a class="xref" href="#/chikramer0022#wrk_ctd">Works Cited</a></p>
<p class="tocbm"><a class="xref" href="#/chikramer0023#index">Index</a></p>
<p class="tocbm"><a class="xref" href="#/chikramer0024#fn_notes">Footnotes</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-kramer-0006.vue?20612092